'use client';

import type { SectionWrapperProps } from './props';

export function SectionWrapper({ number, title, children, isLast }: SectionWrapperProps) {
    return (
        <section className="relative flex gap-4">
            <div className="relative flex flex-col items-center">
                <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border border-mfour-green/30 bg-mfour-green/10 text-small font-semibold text-mfour-green">
                    {number}
                </div>
                <div className="mt-1 w-px flex-1 bg-gradient-to-b from-mfour-green/25 to-transparent" />
            </div>
            <div className="min-w-0 flex-1 pb-6">
                <h3 className="mb-3 pt-1 text-tiny font-semibold uppercase tracking-widest text-default-400">
                    {title}
                </h3>
                {children}
            </div>
        </section>
    );
}
